export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9048.326d17d1.jpg";